module.exports = __webpack_public_path__ + "static/media/provider.ddd70cf9.svg";